module.exports = __webpack_public_path__ + "static/media/happySadFacec2915c94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/happySadFace.svg
// module id = 1331
// module chunks = 0